import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSearchParams } from 'react-router-dom';

/**
 * Bookseller OAuth → LearnLeaf Bearer-token handoff.
 *
 * Background: after a successful bookseller OIDC callback, the server signs the
 * user into LearnLeaf's application-scheme cookie. But the React PWA's `auth`
 * state is driven by `react-oidc-context` which tracks a Bearer token (not a
 * cookie). So we kick the LearnLeaf OIDC code flow here — because the cookie is
 * already set, `/connect/authorize` skips the login UI, mints an authz code,
 * and the standard CallbackPage exchanges it for a Bearer token.
 */
export default function LoginCompletePage() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl') || '/';

  useEffect(() => {
    // Always initiate the code flow — the server-set cookie should make this silent.
    auth.signinRedirect({ state: { returnUrl } }).catch((e) => {
      console.error('LoginComplete signinRedirect failed', e);
      // Fall through — if the redirect fails the user will see an auth error
      // on next navigation; nothing useful to do here besides log.
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <p className="text-neutral-600">Completing sign-in…</p>
      </div>
    </div>
  );
}
